import React, { createContext, useContext, useState } from 'react';

const RefreshContext = createContext();

export const useRefresh = () => {
  const context = useContext(RefreshContext);
  if (!context) {
    throw new Error('useRefresh must be used within RefreshProvider');
  }
  return context;
};

export const RefreshProvider = ({ children }) => {
  const [refreshCallback, setRefreshCallback] = useState(null);

  const setOnRefresh = (callback) => {
    setRefreshCallback(() => callback);
  };

  const clearOnRefresh = () => {
    setRefreshCallback(null);
  };

  const triggerRefresh = async () => {
    if (refreshCallback) {
      await refreshCallback();
    }
  };

  return (
    <RefreshContext.Provider value={{ setOnRefresh, clearOnRefresh, triggerRefresh, hasRefresh: !!refreshCallback }}>
      {children}
    </RefreshContext.Provider>
  );
};
